import React, { useState, useEffect } from "react";
import { collection, where, getDocs, query } from "firebase/firestore";
import { db, db_modular } from "../../firebaseConfig";
import { clsx } from "clsx";
import toast from "react-hot-toast";
import { FiUsers } from "react-icons/fi";
import { FaRegClipboard } from "react-icons/fa";

function ParticipantList({ title, roomId, team, userTeam, type, currentUserPk }) {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    if (!roomId) return;
    const fieldName = `${team}_${type}`;
    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const data = doc.data();
          const pks = data[fieldName] || [];
          if (pks.length > 0) {
            const users = await getDocs(
              query(collection(db_modular, "users"), where("publicKey", "in", pks))
            );
            setParticipants(users.docs.map((v) => v.data()));
          } else {
            setParticipants([]);
          }
        }
      });
    return () => unsubscribe();
  }, [roomId, team, type]);

  const copyToClipboard = (data) => {
    navigator.clipboard.writeText(data).then(() => toast.success("Address Copied"));
  };

  const isSameTeam = team === userTeam;

  return (
    <div className="flex flex-col">
      <div
        className={clsx(
          "px-1 py-1 mb-2 border-b border-white/5 flex items-center justify-between",
          team === "red" ? "text-red-400" : "text-blue-400"
        )}
      >
        <h4 className="text-[12px] font-bold flex items-center gap-2 uppercase tracking-wide opacity-90">
          <FiUsers size={14} />
          {title}
        </h4>
        <span className="text-[11px] font-mono opacity-50">{participants.length}</span>
      </div>
      <div className="grid grid-cols-1 gap-2">
        {participants.length === 0 ? (
          <div className="py-4 px-3 flex items-center gap-3 text-text-muted text-sm opacity-40 bg-white/5 border border-white/5 rounded-xl">
            <FiUsers size={16} />
            <span>No one joined</span>
          </div>
        ) : (
          participants.map((p, i) => (
            <div
              key={i}
              className="bg-white/5 border border-white/10 rounded-xl p-3 hover:bg-white/10 transition-all duration-300 group hover:translate-x-1"
            >
              {isSameTeam && (
                <div className="flex items-center justify-between gap-3 mb-2">
                  <span className="text-[10px] font-mono text-text-muted/70 truncate group-hover:text-white/60 transition-colors">
                    {p.publicKey}
                  </span>
                  <button
                    onClick={() => copyToClipboard(p.publicKey)}
                    className="text-text-muted/50 hover:text-primary transition-colors p-1 hover:bg-white/5 rounded"
                  >
                    <FaRegClipboard size={12} />
                  </button>
                </div>
              )}
              <div className="flex items-center justify-between gap-2">
                <p className="text-sm font-medium text-white/90 truncate">{p.email}</p>
                {p.publicKey === currentUserPk && (
                  <span className="text-primary font-bold text-[10px] bg-primary/10 px-2 py-0.5 rounded-md border border-primary/20 shrink-0 shadow-sm">
                    YOU
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ParticipantList;
